"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.targetCountryLocaleCodesDictionary = exports.targetCountryLocaleCodes = exports.default = void 0;
var _locale = require("@sm/locale");
var _environment = require("@sm/utils/dist/environment");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// fix for downstream tree-shaking

var _getClientEnvironment = (0, _environment.getClientEnvironmentDetails)(),
  isBrowser = _getClientEnvironment.isBrowser;
var currency = ['AFN', 'EUR', 'ALL', 'DZD', 'USD', 'AOA', 'XCD', 'ARS', 'AMD', 'AWG', 'AUD', 'AZN', 'BSD', 'BHD', 'BDT', 'BBD', 'BYN', 'BZD', 'XOF', 'BMD', 'INR', 'BTN', 'BOB', 'BOV', 'BAM', 'BWP', 'NOK', 'BRL', 'BND', 'BGN', 'BIF', 'CVE', 'KHR', 'XAF', 'CAD', 'KYD', 'CLP', 'CLF', 'CNY', 'COP', 'COU', 'KMF', 'CDF', 'NZD', 'CRC', 'HRK', 'CUP', 'CUC', 'ANG', 'CZK', 'DKK', 'DJF', 'DOP', 'EGP', 'SVC', 'ERN', 'ETB', 'FKP', 'FJD', 'XPF', 'GMD', 'GEL', 'GHS', 'GIP', 'GTQ', 'GBP', 'GNF', 'GYD', 'HTG', 'HNL', 'HKD', 'HUF', 'ISK', 'IDR', 'XDR', 'IRR', 'IQD', 'ILS', 'JMD', 'JPY', 'JOD', 'KZT', 'KES', 'KPW', 'KRW', 'KWD', 'KGS', 'LAK', 'LBP', 'LSL', 'ZAR', 'LRD', 'LYD', 'CHF', 'MOP', 'MKD', 'MGA', 'MWK', 'MYR', 'MVR', 'MRO', 'MUR', 'XUA', 'MXN', 'MXV', 'MDL', 'MNT', 'MAD', 'MZN', 'MMK', 'NAD', 'NPR', 'NIO', 'NGN', 'OMR', 'PKR', 'PAB', 'PGK', 'PYG', 'PEN', 'PHP', 'PLN', 'QAR', 'RON', 'RUB', 'RWF', 'SHP', 'WST', 'STD', 'SAR', 'RSD', 'SCR', 'SLL', 'SGD', 'XSU', 'SBD', 'SOS', 'SSP', 'LKR', 'SDG', 'SRD', 'SZL', 'SEK', 'CHE', 'CHW', 'SYP', 'TWD', 'TJS', 'TZS', 'THB', 'TOP', 'TTD', 'TND', 'TRY', 'TMT', 'UGX', 'UAH', 'AED', 'USN', 'UYU', 'UYI', 'UZS', 'VUV', 'VEF', 'VND', 'YER', 'ZMW', 'ZWL', 'XBA', 'XBB', 'XBC', 'XBD', 'XTS', 'XXX', 'XAU', 'XPD', 'XPT', 'XAG'];

/**
 * These locales are needed to correct some formatting issues with pricing related work.
 * The intl API with the correct locale information should override anything paymentweb is doing currently.
 * And since paymentweb has it own rule set we will need to adjust smlib.locale which uses
 * https://github.com/zopefoundation/zope.i18n/tree/master (zope.18n dependency is out of date in smlib.locale)
 * To achieve a parity for all supported currencies we will need to re-access (https://github.com/mntv-python-guild/smlib.locale/blob/main/smlib/locale/locale.yml) to match ICU standards for front-end applications
 */

var targetCountryLocaleCodesDictionary = exports.targetCountryLocaleCodesDictionary = Object.freeze({
  BR: 'pt-BR',
  PT: 'pt-PT',
  CH: 'de-CH',
  AR: 'es-AR',
  BO: 'es-BO',
  CL: 'es-CL',
  CO: 'es-CO',
  CR: 'es-CR',
  CU: 'es-CU',
  EC: 'es-EC',
  SV: 'es-SV',
  GT: 'es-GT',
  HN: 'es-HN',
  MX: 'es-MX',
  NI: 'es-NI',
  PA: 'es-PA',
  PY: 'es-PY',
  PE: 'es-PE',
  PR: 'es-PR',
  DO: 'es-DO',
  UY: 'es-UY',
  VE: 'es-VE'
});
var targetCountryLocaleCodes = exports.targetCountryLocaleCodes = function targetCountryLocaleCodes(billingCountry, currentLocale) {
  var k = Object.keys(targetCountryLocaleCodesDictionary);
  if (k.includes(billingCountry) && currentLocale.includes((0, _locale.getLanguageCodeFromCountryCode)(billingCountry))) {
    return targetCountryLocaleCodesDictionary[billingCountry];
  }
  return currentLocale;
};

/** List of supported currencies */

var numberFormat = currency.reduce(function (acc, key) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, {
    style: 'currency',
    currency: key
  }));
}, {});
var dateTimeFormat;
if (isBrowser) {
  var browserTimezone = 'UTC';
  try {
    browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    dateTimeFormat = {
      timeZone: browserTimezone
    };
  } catch (err) {
    // We're throwing in a settimeout because we don't want to break the current tick.
    window.setTimeout(function () {
      throw err;
    }, 1);
  }
}
var _default = exports.default = {
  number: numberFormat,
  dateTime: dateTimeFormat,
  relativeTime: undefined
};
//# sourceMappingURL=formats.js.map